const Utils = {
    /**
     * Selector for elements that can receive keyboard focus.
     * Shared by focus traps, skip links, etc.
     */
    FOCUSABLES: [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'iframe',
        'object',
        'embed',
        '[contenteditable]',
        '[tabindex]:not([tabindex="-1"])',
    ].join(', '),

    /**
     * Returns focusable descendants of `container` that are actually
     * available to the keyboard (visible, not inert / aria-hidden).
     * @param {ParentNode} container
     * @returns {HTMLElement[]}
     */
    getFocusables(container) {
        if (!container) return []

        return Array.from(container.querySelectorAll(this.FOCUSABLES)).filter((el) => {
            if (el.closest('[inert]')) return false
            if (el.closest('[aria-hidden="true"]')) return false
            if (el.getAttribute('tabindex') === '-1') return false
            return el.getClientRects().length > 0
        })
    },

    /**
     * Returns a debounced version of a function that delays invoking
     * `fn` until `wait` ms have elapsed since the last time it was called.
     * @param {Function} fn - The function to debounce.
     * @param {number} wait - Delay in milliseconds.
     * @returns {Function} The debounced function.
     */
    debounce(fn, wait = 100) {
        let timeoutId

        return function debounced(...args) {
            const context = this

            clearTimeout(timeoutId)
            timeoutId = setTimeout(() => {
                fn.apply(context, args)
            }, wait)
        }
    },
}

export default Utils
